import { FunctionComponent, h } from 'preact'

import { htmlEncodeByRegExp } from 'scripts/utils'
import classes from './description.module.scss'
import { Field } from 'scripts/type'

const DescriptionField: FunctionComponent<{ field: Field }> = ({ field }) => {
  const content = htmlEncodeByRegExp(field.description!)
  return <div className={classes.descriptionField} dangerouslySetInnerHTML={{ __html: content! }} />
}

export default DescriptionField
